import * as tslib_1 from "tslib";
import styled, { css } from 'styled-components';
import classNames from 'classnames';
import Typography from '../Typography';
var flexStyle = css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 16px;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 16px;\n"])));
// 提示框标题
var DialogTitle = styled(Typography).attrs({
    type: 'title',
    className: function (props) { return classNames('sinoui-dialog-title', props.className); },
})(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  padding: 24px 24px 20px 24px;\n  margin: 0;\n  flex: 0 0 auto;\n  user-select: none;\n  cursor: move;\n\n  ", ";\n"], ["\n  padding: 24px 24px 20px 24px;\n  margin: 0;\n  flex: 0 0 auto;\n  user-select: none;\n  cursor: move;\n\n  ", ";\n"])), function (props) { return props.showCloseIcon && flexStyle; });
DialogTitle.sinouiName = 'DialogTitle';
export default DialogTitle;
var templateObject_1, templateObject_2;
//# sourceMappingURL=DialogTitle.js.map